module.exports = "<div class=\"footer-fixed-login\">\n    <div style=\"margin-right: 5px;\">Copyright © Tahoservis Perović 2022</div>\n</div>"